import { SVGProps } from 'react';
const SvgRadioFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z"
    />
  </svg>
);
export default SvgRadioFill;
